<lui-dialog-container class="dialog-container">
  <lui-dialog-header>
    <div class="mat-h2" i18n>Document upload</div>

    <div class="mt-1">
      <ng-container *ngTemplateOutlet="pathBlock"></ng-container>
    </div>

    <button
      luiDialogClose
      luiIconButton
      size="xl"
      aria-label="Close"
      i18n-aria-label
    >
      <mat-icon svgIcon="close_light"></mat-icon>
    </button>
  </lui-dialog-header>

  <lui-dialog-content>
    <ng-container *ngIf="!createNewFolderView; else newFolderBlock">
      <div class="upload-ref" *ngIf="data.path">
        <div class="text-center py-1" *ngIf="!newFolderName; else pathBlock">
          <button
            luiCab
            size="lg"
            (click)="onCreateNewFolderClick()"
            iconPosition="start"
            i18n
          >
            <mat-icon svgIcon="folder_add"></mat-icon>
            Create a new folder
          </button>
        </div>
      </div>
      <lui-file-drag-and-drop
        [value]="files.selected"
        [button]="uploadButton"
        (filesChanged)="onFilesDropped($event)"
        [accept]="acceptedFileTypes"
        (filesRejected)="onFilesRejected($event)"
      >
        <div class="upload-box">
          <lui-avatar
            color="primary"
            [size]="24"
            class="position-absolute top-2 end-2"
            [matTooltip]="
              acceptedFilesPrefix + ': ' + acceptedFileTypesDescription
            "
          >
            <mat-icon svgIcon="i"></mat-icon>
          </lui-avatar>

          <lui-avatar color="grayMedium">
            <mat-icon svgIcon="doc_upload_thin"></mat-icon>
          </lui-avatar>
          <div>
            <ng-container i18n>Drag and drop your files here</ng-container
            >&nbsp;<span class="mat-body-strong" i18n>or</span>
          </div>
          <span #uploadButton>
            <button luiButton class="mt-2" i18n>Browse files</button>
          </span>
        </div>
      </lui-file-drag-and-drop>

      <div *ngIf="rejectedFiles" class="mat-xs text-danger">
        <span i18n> The following files were rejected </span>
        <div *ngFor="let file of rejectedFiles">
          {{ file.name }}
        </div>
      </div>

      <div class="mt-3" *ngIf="files && files.selected.length">
        <ng-content></ng-content>
      </div>
    </ng-container>
  </lui-dialog-content>
  <lui-dialog-actions align="center" *ngIf="files.selected.length">
    <button luiButton (click)="uploadFiles()" i18n>Finish & view</button>
  </lui-dialog-actions>
</lui-dialog-container>

<ng-template #newFolderBlock>
  <div class="box rounded" *ngIf="data.path">
    <div class="d-flex">
      <div class="flex-1">
        <div class="mat-h3" i18n>Create a new folder</div>
      </div>
      <div class="flex-none">
        <button
          luiIconButton
          (click)="onCancelCreateNewFolderClick()"
          aria-label="Close"
          i18n-aria-label
        >
          <mat-icon svgIcon="close"></mat-icon>
        </button>
      </div>
    </div>

    <div class="mt-2 mb-3" *ngIf="data.pathPrefix">
      <div class="hstack">
        <lui-avatar class="me-1" color="grayMedium" [size]="48">
          <mat-icon svgIcon="folder_thin"></mat-icon>
        </lui-avatar>
        <span>
          {{ data.pathPrefix }} /
          <ng-container i18n>Documents home</ng-container>
          <ng-container *ngIf="data.path.length">
            / {{ data.path | join : ' / ' }}
          </ng-container>
          <ng-container *ngIf="newFolderNameControl.value">
            / <span class="fw-b">{{ newFolderNameControl.value }}</span>
          </ng-container>
        </span>
      </div>
    </div>

    <div class="d-flex gap-1 pb-2">
      <div class="flex-1 flex-wrap">
        <mat-form-field>
          <mat-label i18n>Folder name</mat-label>
          <input
            matInput
            [formControl]="newFolderNameControl"
            autocomplete="off"
          />
        </mat-form-field>
      </div>
      <div>
        <button luiButton (click)="createFolder()" i18n>Create folder</button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #pathBlock>
  <div class="hstack" *ngIf="data.path">
    <lui-avatar class="me-1" color="grayMedium" [size]="48">
      <mat-icon svgIcon="folder_thin"></mat-icon>
    </lui-avatar>
    <span>
      <span class="fw-b" *ngIf="data.pathPrefix"> {{ data.pathPrefix }}</span>
      <span *ngIf="data.pathPrefix"> / </span>
      <ng-container *ngIf="data.path.length">
        {{ data.path | join : ' / ' }}
      </ng-container>
      <ng-container *ngIf="newFolderName"> / {{ newFolderName }} </ng-container>
    </span>
  </div>
</ng-template>
